import { Checkbox, Text } from '@myinterview/component-library';
import React, { useEffect, useState } from 'react';
import { IMultipleChoiceOptionDefinition } from '../interfaces/jobInterface';
import { IMultipleAnswer } from '../interfaces/videoInterface';

interface IProps {
  answerOptions: IMultipleChoiceOptionDefinition[];
  onAnswer: (answers: IMultipleAnswer[]) => void;
}

export const AssessmentMultiSelect:React.FC<IProps> = ({ answerOptions, onAnswer }) => {
  const [selectedAnswersIds, setSelectedAnswersIds] = useState<IMultipleAnswer[]>(answerOptions.map((answer) => ({ ...answer, selected: false })));

  const handleChange = (e: React.ChangeEvent<HTMLFormElement>) => {
    const { value, checked } = e.target;
    setSelectedAnswersIds((prev) => prev.map((answer) => (answer.id !== value ? answer : { ...answer, selected: checked })));
  };

  useEffect(() => {
    onAnswer(selectedAnswersIds);
  }, [selectedAnswersIds]);

  return (
    <div className="myinterview-widget-assessment__multi-select">
      <form
        className="myinterview-widget-assessment__options-form"
        style={{ display: 'flex', flexDirection: 'column' }}
        onChange={handleChange}
      >
        {selectedAnswersIds.map((answer) => (
          <label
            key={answer.id}
            className="myinterview-widget-assessment__option myinterview-text--S"
          >
            <Checkbox
              inputAttributs={{ name: 'multi-answer', value: answer.id, readOnly: true }}
              checked={answer.selected}
            />
            <Text size="S-Regular">{answer.label}</Text>
          </label>
        ))}
      </form>
    </div>
  );
};
